<mat-option class="nv-mat-option nv-mat-option-empty_state_action " [value]="''">
  <nv-icon *ngIf="showIcon" [name]="icon"></nv-icon>
  <ng-content></ng-content>
</mat-option>
